import App from "@/App.vue";
import { filters } from "@/aygulyazilim/filters";
import { registerPlugins } from "@core/utils/plugins";
import { createApp } from "vue";
import Vue3Filters from "vue3-filters";

// Styles
import "@core/scss/template/index.scss";
import "@styles/styles.scss";

// Syncfusion Teması (Vuexy'nin stiliyle uyumlu olması için material temasını seçebiliriz)
// import "@syncfusion/ej2-base/styles/material.css";
// import "@syncfusion/ej2-buttons/styles/material.css";
// import "@syncfusion/ej2-calendars/styles/material.css";
// import "@syncfusion/ej2-dropdowns/styles/material.css";
// import "@syncfusion/ej2-grids/styles/material.css";
// import "@syncfusion/ej2-inputs/styles/material.css";
// import "@syncfusion/ej2-navigations/styles/material.css";

// Syncfusion Vue Eklentileri
// import { registerLicense } from "@syncfusion/ej2-base";
// import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
// import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
// import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
// import { GridPlugin } from "@syncfusion/ej2-vue-grids";
// import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";

// Create vue app
const app = createApp(App);

// Syncfusion Eklentilerini Kaydet
// app.use(ButtonPlugin);
// app.use(TextBoxPlugin);
// app.use(DatePickerPlugin);
// app.use(DropDownListPlugin);
// app.use(GridPlugin); // Grid'i burada genel olarak kaydediyoruz
// Registering Syncfusion license key
// const SYNCFUSION_LICENSE_KEY =
//   "Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZednVSRWVZUUN/WEtWYEg=";
// registerLicense(SYNCFUSION_LICENSE_KEY);
// import textDirectives from "@/aygulyazilim/directives/text";
// import inputUpper from "@/aygulyazilim/directives/text/inputUpper";
// app.directive("input-upper", inputUpper);
// app.directive("strToUpper", textDirectives.strToUpper);
// app.directive("capitalize", textDirectives.capitalize);
// app.directive("lowerCase", textDirectives.lowerCase);

// import inputDecimalFormat from "@/aygulyazilim/directives/sayi/inputDecimalFormat";
// app.directive("input-decimal-format", inputDecimalFormat);

// Register plugins
registerPlugins(app);

// app.mixin(Vue3Filters.mixin);

app.config.globalProperties.$filters = { ...Vue3Filters.filters, ...filters };

// .env dosyasındaki VITE_API_BASE_URL değişkenini global olarak tanımlıyoruz
app.config.globalProperties.$config = {
  apiBaseUrl: import.meta.env.VITE_API_ENDPOINT.endsWith("/")
    ? import.meta.env.VITE_API_ENDPOINT
    : import.meta.env.VITE_API_ENDPOINT + "/",
};

// Mount vue app
app.mount("#app");

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js");
    // .then((reg) => console.log("SW kayıt edildi:", reg))
    // .catch((err) => console.log("SW hatası:", err));
  });
}
